<script>
  import { onMount } from 'svelte';
  import ProductCard from './ProductCard.svelte';
  import trackOpen from '../events/trackOpen';
  import trackScroll from '../events/trackScroll';

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */

  /*                */
  let {
    recommendations,
    featureIndex,
    widgetTracking,
    widgetAdditionalClickTracking,
    pageName,
    trackOpenAndScroll = false,
    featuresState = {}
  } = $props();

  let firstIntersectionEvent = true;
  const visibleCardsTracking = {};
  const visibleCardsIndexes = new Set();

  onMount(() => {
    o_global.eventQBus.on('ft6bcn.reco-aos-frontend.a2b-banner-close', () => {});
  });

  const cardIsFullyVisible = (card) => card.intersectionRatio === 1;

  const calculateScrollDirection = (entries) => {
    const rotatingCard = entries[0];
    const rotatingCardIndex = rotatingCard.target.getAttribute('elementIndex');
    const cardIsNew = cardIsFullyVisible(rotatingCard);
    const minIndex = Math.min(...visibleCardsIndexes);
    const cardEntersAbove = rotatingCardIndex < minIndex && cardIsNew;
    const cardExitsBelow = !(rotatingCardIndex <= minIndex) && !cardIsNew;
    return cardEntersAbove || cardExitsBelow ? 'previous' : 'next';
  };

  const updateVisibleCardsIndexes = (entries) => {
    entries.forEach((entry) => {
      const index = entry.target.getAttribute('elementIndex');
      if (cardIsFullyVisible(entry)) {
        visibleCardsIndexes.add(index);
      } else {
        visibleCardsIndexes.delete(index);
      }
    });
  };

  const updateVisibleCardsTracking = (entries) => {
    entries.forEach((entry) => {
      const tracking = entry.target.getAttribute('tracking');
      if (cardIsFullyVisible(entry)) {
        visibleCardsTracking[tracking] = true;
      } else {
        delete visibleCardsTracking[tracking];
      }
    });
  };

  const handleIntersect = (entries) => {
    const scrollDirection = calculateScrollDirection(entries);
    updateVisibleCardsIndexes(entries);
    updateVisibleCardsTracking(entries);
    if (!entries.some(cardIsFullyVisible)) {
      return;
    }
    if (firstIntersectionEvent) {
      trackOpen(widgetTracking, Object.keys(visibleCardsTracking).map(JSON.parse), 99);
      firstIntersectionEvent = false;
      return;
    }
    trackScroll(
      widgetTracking,
      Object.keys(visibleCardsTracking).map(JSON.parse),
      99,
      scrollDirection
    );
  };

  const observer = new IntersectionObserver(handleIntersect, {
    rootMargin: '0px',
    threshold: 1.0
  });

  const observeCard = (card, cardTracking, cardIndex) => {
    if (!trackOpenAndScroll) {
      return;
    }
    card.setAttribute('tracking', JSON.stringify(cardTracking));
    card.setAttribute('elementIndex', cardIndex);
    observer.observe(card);
  };

  const add2basketErrorCallback = () => {
    bannerHandler(true);
  };

  const bannerHandler = (showErrorBanner) => {
    const add2baskErrorBanner = document.querySelectorAll('.reco_aos_error_banner');
    add2baskErrorBanner.forEach((banner) => {
      const displayStyle = showErrorBanner === true ? '' : 'display: none;';
      banner.setAttribute('style', displayStyle);
    });
  };
</script>

<div class="reco_aos_product_card_list">
  <oc-banner-v1
    size="100"
    variant="error"
    hide-icon
    class="reco_aos_error_banner reco_aos_banner_component"
    style={'display: none;'}
    onoc-banner-close={bannerHandler}>
    <span>Leider ist ein Problem beim hinzufügen aufgetreten. Bitte probiere es erneut.</span>
  </oc-banner-v1>

  {#each recommendations as recommendation, position}
    <ProductCard
      {recommendation}
      {featureIndex}
      {add2basketErrorCallback}
      {widgetTracking}
      {widgetAdditionalClickTracking}
      {pageName}
      {observeCard}
      {position}
      {featuresState} />
    {#if position !== recommendations.length - 1}
      <oc-divider-v1 class="reco_aos_recommendation_divider"></oc-divider-v1>
    {:else}
      <hr class="reco_aos_hr" />
    {/if}
  {/each}
</div>

<style lang="scss">
  .reco_aos_recommendation_divider {
    margin-top: 24px;
    border: 0.5px solid var(--oc-semantic-color-disabled-background);
  }

  .reco_aos_hr {
    border: 0.5px solid var(--oc-semantic-color-disabled-background);
    border-radius: 5px;
    margin-top: 24px;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .reco_aos_hr:last-child {
    display: none;
  }

  .reco_aos_error_banner {
    margin-top: 24px;
  }

  .reco_aos_banner_component {
    margin-top: 16px;
  }
</style>
